import BigNumber from 'bignumber.js';

import { AddProductToChargeDetails } from 'application-types';
import { getPricing, multiplyByQuantity } from 'domains-billing-calculation';
import {
  type SupportedPaymentCurrency,
  getCurrencyPrecision,
} from 'domains-billing-currency';
import { SupportedLocaleEnum } from 'localization';
import { priceInputToComponents } from 'lane-shared/domains/billingPayments/helpers';

export function getChargeAmounts(
  listOfProducts: AddProductToChargeDetails[],
  currency: SupportedPaymentCurrency,
  locale: SupportedLocaleEnum,
  isAdminFeeFeatureEnabled = false
) {
  const precision = getCurrencyPrecision(currency);
  let subTotal = new BigNumber(0);
  let tax = new BigNumber(0);
  let adminFeeTax = new BigNumber(0);
  let total = new BigNumber(0);

  listOfProducts.forEach((product) => {
    const priceComponents = priceInputToComponents(product);

    if (product.sellingPrice) {
      priceComponents.sellingPrice = product.sellingPrice;
    }

    const pricing = getPricing({
      currency,
      locale,
      priceComponents,
      isAdminFeeFeatureEnabled,
    });

    const quantity = new BigNumber(product.quantity);

    subTotal = subTotal.plus(multiplyByQuantity(pricing.listPrice, quantity, precision));
    tax = tax.plus(multiplyByQuantity(pricing.grossTax, quantity, precision));
    adminFeeTax = adminFeeTax.plus(multiplyByQuantity(pricing.grossAdminFeeTax, quantity, precision));
    total = total.plus(multiplyByQuantity(pricing.netPrice, quantity, precision));
  });

  return {
    subTotal: subTotal.toNumber(),
    tax: tax.toNumber(),
    adminFeeTax: adminFeeTax.toNumber(),
    total: total.toNumber(),
  };
}
